import { Component } from 'react';
import { Container, Button, Row, Col } from 'reactstrap';
import Toolbar from '../../basic/Toolbar';
import { ToolbarLinkButton } from '../../basic/Button';
import { SplitByBusinessUnitModel, EpicSplitClient } from '../../../client/ApiClient';
import { DataTable, DataRow, DataCell } from 'components/basic/DataTable';

interface EpicSplitByBusinessUnitListState {
    splits: SplitByBusinessUnitModel[] | null;
}

class EpicSplitByBusinessUnitList extends Component<{}, EpicSplitByBusinessUnitListState> {
    private client: EpicSplitClient = new EpicSplitClient();
    private refreshInterval: NodeJS.Timeout | null = null;

    constructor(props: {}) {
        super(props);
        this.state = {
            splits: null
        };
    }

    componentDidMount() {
        this.fetchSplits();
        this.refreshInterval = setInterval(this.fetchSplits, 5000);
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    fetchSplits = () => {
        this.client.listAll().then(result => {
            this.setState({ splits: result });
        }).catch(err => {
            // Optionally handle error
        });
    }

    isNullOrEmpty(value: string | null | undefined): boolean {
        return value === null || value === undefined || value.toString().trim() === '';
    }

    handleCreate = () => {
        window.location.href = '/tools/split/epic/new';
    }

    public render() {
        return (
            <Container className="mt-4">
                <Row className="mb-2">
                    <Col xs={8} md={9}><h4>Epic Split By Business Unit List</h4></Col>
                    <Col xs={4} md={3}><Button color='secondary' className='submit-button-orange' onClick={this.handleCreate}>Create New Split</Button></Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={12} md={12}>
                        <DataTable>
                            <thead>
                                <tr>
                                    <th>Original Database</th>
                                    <th>Filtered Database</th>
                                    <th>Filter</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.splits?.map(item => (
                                    <DataRow id={item.id} key={item.id} onClick={() => window.location.href = `/tools/split/epic/${item.id}`} style={{ cursor: 'pointer' }}>
                                        <DataCell>{item.originalDatabaseName}</DataCell>
                                        <DataCell>{item.filteredDatabaseName}</DataCell>
                                        <DataCell>
                                            {this.isNullOrEmpty(item.agencyList) ? "" : "Agency"}
                                            {(!this.isNullOrEmpty(item.agencyList) && !this.isNullOrEmpty(item.branchList)) ? ", " : ""}
                                            {this.isNullOrEmpty(item.branchList) ? "" : "Branch"}
                                            {((!this.isNullOrEmpty(item.agencyList) || !this.isNullOrEmpty(item.branchList)) && !this.isNullOrEmpty(item.departmentList)) ? ", " : ""}
                                            {this.isNullOrEmpty(item.departmentList) ? "" : "Department"}
                                        </DataCell>
                                        <DataCell>{item.status}</DataCell>
                                    </DataRow>
                                ))}
                            </tbody>
                        </DataTable>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default EpicSplitByBusinessUnitList;